<script setup lang="ts">
import CreateTableOption from './CreateTableOption.vue'
import CreateElementalOption from './CreateElementalOption.vue'
import { useLeftSidebarStore } from '~~/src/stores/leftSidebar'
import Menu from '@/components/FloatMenu/indev.vue'
import { ElementalTypeEnum } from '~~/src/types/elemental'

const props = defineProps<{ isMobile: Boolean }>()

const state = useLeftSidebarStore()
const user = useUser()
const router = useRouter()

const showText = computed(() => {
  return props.isMobile || state.isOpen
})

const handlerSelect = (type: ElementalTypeEnum) => {
  if (!user.value)
    router.push(useGetLoginURL())
  const route = getElementalTypeRoute(type)
  state.toggleSidebar(false)
  state.toggleSidebar(false)
  router.push(`/${route}/create`)
}

const Elementals = [
  {
    type: ElementalTypeEnum.Prompt,
    label: 'Prompt',
    color: getElementTypeColor(ElementalTypeEnum.Prompt),
  },
  {
    type: ElementalTypeEnum.Automation,
    label: 'Automation',
    color: getElementTypeColor(ElementalTypeEnum.Automation),
  },
  {
    type: ElementalTypeEnum.Snippet,
    label: 'Snippet',
    color: getElementTypeColor(ElementalTypeEnum.Snippet),
  },
  {
    type: ElementalTypeEnum.Document,
    label: 'Document',
    color: getElementTypeColor(ElementalTypeEnum.Document),
  },
  {
    type: ElementalTypeEnum.Table,
    label: 'Table',
    color: getElementTypeColor(ElementalTypeEnum.Table),
  },
  {
    type: ElementalTypeEnum.List,
    label: 'List',
    color: getElementTypeColor(ElementalTypeEnum.List),
  },
  {
    type: ElementalTypeEnum.Image,
    label: 'Image',
    color: getElementTypeColor(ElementalTypeEnum.Image),
  },
]
</script>

<template>
  <div class="block w-full min-w-12 px-1.5">
    <Menu :position=" state.isOpen ? 'bottom-left' : 'right'" container-class="min-w-60" :offset="4">
      <template #default="{ toggle }">
        <AppButton
          type="button"
          title="Create/Sell"
          class="relative min-w-12 w-full h-12 p-0 px-2 !bg-soft-black/95 !color-white !hover:bg-soft-black disabled:cursor-not-allowed border-2 border-black justify-start"
          :class="[
            !state.isOpen && '!gap-0 w-12',
          ]"
          :text-style="{
            'width': '100%',
            'height': '100%',
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            'flex-wrap': 'nowrap',
            'position': 'absolute',
            'left': 0,
            'top': 0,
          }"
          @click="toggle()"
        >
          <template #icon>
            <div
              i-mdi:plus
              text="24px" transition-all flex-shrink-0
            />
          </template>

          <TransitionFade>
            <TextV2
              v-if="isMobile || (state.isOpen && showText)"
              class="absolute font-bold text-[16px] "
            >
              Create/Sell
            </TextV2>
          </TransitionFade>

          <div />
        </AppButton>
      </template>
      <template #options>
        <template
          v-for="elemental in Elementals"
          :key="elemental.type"
        >
          <CreateElementalOption v-if="elemental.type !== ElementalTypeEnum.Table" :type="elemental.type" :label="elemental.label" />
          <CreateTableOption v-else-if="elemental.type === ElementalTypeEnum.Table" />
        </template>
      </template>
    </Menu>
  </div>
</template>
